<template>
    <DCard
        padding
    >
        <div class="mb-5">
            <h4>
                {{ template.brand_id === null ? __('tools.sms.default') : template.brand.name }} ({{ template.language_code }}) - {{ __(`tools.sms.templates.${template.name}.name`) }}
            </h4>
            <span class="text-muted fst-italic">
                {{ __(`tools.sms.templates.${template.name}.description`) }}
            </span>
        </div>
        <DForm @submit.prevent>
            <DRow>
                <DCol col="7">
                    <DFormRow
                        class="mb-4"
                        is-vertical
                        :label="__('tools.sms.brand')"
                        is-required
                        :error="errors.brand"
                    >
                        <DSelect
                            v-model="form.brand"
                            disabled
                            :options="brandOptions"
                        />
                    </DFormRow>
                    <DFormRow
                        class="mb-4"
                        is-vertical
                        :label="__('tools.sms.content')"
                        is-required
                        :error="errors.content"
                        :hint="contentLength + '/459 characters'"
                    >
                        <DFormTextarea
                            id="content"
                            v-model="form.content"
                            rows="15"
                            @update:modelValue="contentLengthUpdate"
                        />
                    </DFormRow>
                </DCol>
                <DCol col="5">
                    <h2 class="h5">
                        {{ __('tools.emails.footer_legal_info.legend') }}
                    </h2>
                    <EmailPlaceholders :placeholders="placeholders" />
                </DCol>
            </DRow>
        </DForm>
        <DFabs>
            <DFab
                id="btn-save"
                icon="eye"
                :label="__('messages.preview')"
                @click="openPreviewModal"
            />
        </DFabs>
    </DCard>
    <PreviewContentModal
        v-if="showPreviewModal"
        :show-modal="showPreviewModal"
        :sms-type="form.smsType"
        :content="form.content"
        @submit="submitForm"
        @closeModal="closePreviewModal"
    />
</template>

<script setup>
import { computed, ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import EmailPlaceholders from '~@/Components/Tools/Emails/Placeholders'
import PreviewContentModal from '~@/Components/Tools/Sms/PreviewContentModal'

const props = defineProps({
    template: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    brands: {
        type: Array,
        default: () => { return [] }
    },
    placeholders: {
        type: Object,
        default: () => { return {} }
    }
})

const showPreviewModal = ref(false)

function openPreviewModal () {
    showPreviewModal.value = true
}

function closePreviewModal () {
    showPreviewModal.value = false
}

const form = useForm({
    brand: props.template.brand_id,
    content: props.template.content,
    smsType: props.template.name,
    language_code: props.template.language_code
})

const brandOptions = computed(() => {
    const options = props.brands.map((brand) => {
        return {
            label: brand.name,
            value: brand.id
        }
    })

    options.unshift({
        label: '',
        value: null,
        disabled: true,
        hidden: true,
        selected: true
    })

    return options
})

const contentLength = ref(form.content?.length ?? 0)

function contentLengthUpdate () {
    contentLength.value = form.content.length
}

function submitForm () {
    form.patch(route('tools.sms-templates.update'))
}

</script>
